module.exports = __webpack_public_path__ + "static/media/success6.c856b743.png";